module.exports = __webpack_public_path__ + "img/1.897382e5.png";